import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import axiosInstance from "../../api/axiosInstance";

export const useYears = () => {
  const { token, user } = useSelector((state) => state.user);
  const userId = user?.UserId || user?.pk || "anonymous";

  return useQuery({
    queryKey: ["years", userId, token ? "authenticated" : "guest"],
    queryFn: async () => {
      const response = await axiosInstance.get("api/allyears");
      return response.data;
    },
    enabled: Boolean(token),
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
};
